export default __webpack_public_path__ + "static/media/add-to-the-call-tour.0d43ae42.png";